import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import type { InternalCalibrationArea } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { DeleteConfirmButton } from '../DeleteConfirmButton'

type Props = {
  onClickCalibrationArea: (area: InternalCalibrationArea) => void
  calibrationAreas: InternalCalibrationArea[]
  deleteCalibrationArea: (id: string) => void
}

export const CalibrationAreaTable: FC<Props> = ({
  onClickCalibrationArea,
  calibrationAreas,
  deleteCalibrationArea,
}) => {
  return (
    <TableContainer sx={{ overflowX: 'auto' }}>
      <Table sx={{ bgcolor: 'white', width: '100%' }}>
        <TableHead>
          <TableRow
            sx={{
              '& th': {
                px: 2,
                py: 1,
                whiteSpace: 'nowrap',
              },
            }}
          >
            <TableCell>位置補正基準</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {calibrationAreas.map((item, i) => (
            <TableRow
              key={item.id}
              sx={{
                cursor: 'pointer',
                '&:hover': { backgroundColor: 'action.hover' },
                '& td': { py: 2 },
              }}
            >
              <TableCell onClick={() => onClickCalibrationArea(item)}>
                {i + 1}
              </TableCell>
              <TableCell>
                <DeleteConfirmButton
                  name="位置補正基準"
                  onDelete={() => deleteCalibrationArea(item.id)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
